import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class SolicitePedidoService {

  constructor(private httpService: HttpService) { }

  prepaidOrderSearch(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/prepago/prepaidOrderSearch', data, successHandle, errorHandle);

  }

  getTitulo(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/prepago/generatePrepaid', data, successHandle, errorHandle);

  }

  getDanfePdf(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/prepago/getDanfePdf', data, successHandle, errorHandle);

  }
 
  deletePedido(data, successHandle: Function, errorHandle: Function){
    return this.httpService.doDelete('/prepago/pedido/'+data, successHandle, errorHandle);
  }

  getPedido(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/prepago/pedido/'+data+'/pagamento', null, successHandle, errorHandle);

  }
  

}
